export function loadGoogleAnalytics(trackingId) {
  if (!trackingId) return;

  // すでに読み込み済みかチェック (id="ga-script" で判断)
  if (document.getElementById("ga-script")) return;

  // GA用スクリプトタグを作成
  const script = document.createElement("script");
  script.id = "ga-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
  document.head.appendChild(script);

  // gtag の初期化
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", trackingId);
  };
}

export function removeGoogleAnalytics() {
  const script = document.getElementById("ga-script");
  if (script) {
    script.remove();
  }
}

export function loadGoogleAdSense(clientId) {
  if (!clientId) return;

  // すでに読み込み済みかチェック (id="adsense-script" で判断)
  if (document.getElementById("adsense-script")) return;

  // AdSense用スクリプトタグを作成
  const script = document.createElement("script");
  script.id = "adsense-script";
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
  script.crossOrigin = "anonymous";
  document.head.appendChild(script);

  // window.adsbygoogleを使用して未定義エラーを回避
  script.onload = () => {
    (window.adsbygoogle = window.adsbygoogle || []).push({
      google_ad_client: clientId,
      enable_page_level_ads: true,
    });
  };
}

export function removeGoogleAdSense() {
  const script = document.getElementById("adsense-script");
  if (script) {
    script.remove();
  }
}